/* eslint-disable prettier/prettier */
import React from 'react';
import { Activity } from '../../types/schedule.types';
import { ACTIVITY_TYPE_MAP } from '../../constants/activitytypes.constant';
import styles from '../../styles/Schedule/ActivityCard.module.css';
import { toLocalTimeHM } from '../../utils/dateUtils';

interface ActivityCardProps {
	activity: Activity;
	onClick?: (activity: Activity) => void;
	/**
	 * 'default' — full card used in the week view.
	 * 'compact' — denser card used inside month-grid day cells.
	 */
	variant?: 'default' | 'compact';
}

const ActivityCard: React.FC<ActivityCardProps> = ({
	activity,
	onClick,
	variant = 'default',
}) => {
	// Prefer the per-activity colour from the backend; fall back to the
	// type config, then a neutral grey. (Accepts either `activitytype`
	// or the legacy `type` field for the config lookup.)
	const typeKey = activity.activitytype || activity.type;
	const config = typeKey ? ACTIVITY_TYPE_MAP[typeKey] : undefined;
	const activityColor =
		activity.activitytypecolor || config?.color || '#6B7280';
	const isCompleted = new Date(activity.endTime) < new Date();

	return (
		<div
			className={`${styles.card} ${variant === 'compact' ? styles.compact : ''}`}
			style={{
				backgroundColor: isCompleted
					? '#F3F4F6' // grey for completed activities
					: `${activityColor}20`,
				borderBottomColor: activityColor,
			}}
			onClick={() => onClick?.(activity)}
			role={onClick ? 'button' : undefined}
			tabIndex={onClick ? 0 : undefined}
			title={activity.title}
		>
			{/* <p className={styles.time}>
                {toLocalTimeHM(activity.startTime)}-{toLocalTimeHM(activity.endTime)}
            </p>
            <p className={styles.title}>{activity.title}</p> */}
			<p
				className={styles.time}
				style={{
					color: isCompleted ? '#9CA3AF' : undefined,
				}}
			>
				{toLocalTimeHM(activity.startTime)}-
				{toLocalTimeHM(activity.endTime)}
			</p>

			<p
				className={styles.title}
				style={{
					color: isCompleted ? '#6B7280' : undefined,
				}}
			>
				{activity.title}
			</p>
		</div>
	);
};

export default ActivityCard;
